module.exports = __webpack_public_path__ + "media/apps/mitch-ios-8-a801c13e.png";